module.exports = __webpack_public_path__ + "call-tel.png?421f0677f4531b0a1f65b54bb58a8f8e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/call-tel.png
// module id = 154
// module chunks = 0